import "../styles/CatalogSearch.scss";
import Search from "./Search.js";

window.CatalogSearch = {
    Search
};